import React from 'react';

import { Tooltip } from 'antd';
import { TFuncKey, useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';

interface IProps {
  path: string;
}

const WRAPPERS = ['ИдСв', 'СвЮЛУч', 'АдрРФ', 'ФИО'];

export const EpdFieldName: React.FC<IProps> = ({ path }) => {
  const epdT = useTranslation(NSKeys.epd);
  const names = path
    .split('/')
    .map((part) => part.replace(/\[\d+\]$/, ''))
    .filter((part) => part && !/^\d+$/.test(part) && !WRAPPERS.includes(part))
    .map((part) => epdT.t(`fieldParts.${part as TFuncKey<'epd', 'fieldParts'>}` as const, { defaultValue: '' }));
  if (!names.length || names.some((name) => !name)) return <>{path || '—'}</>;
  const label = names.join(' — ');
  return (
    <Tooltip title={path}>
      <span>{label.charAt(0).toUpperCase() + label.slice(1)}</span>
    </Tooltip>
  );
};
